import React, { useState, useEffect } from 'react';
import { Button } from '@rmwc/button';
import '@rmwc/button/styles';
import { Snackbar } from '@rmwc/snackbar';
import '@rmwc/snackbar/styles';
import { useFlexionStore } from '../Stores';
import { getText } from '../Helpers';

function ResetM() {
  const Sprache = useFlexionStore((state) => state.Sprache);
  const setLänge = useFlexionStore((state) => state.setLänge);
  const setErsterPunktDistanz = useFlexionStore((state) => state.setErsterPunktDistanz);
  const setErsterPunktLast = useFlexionStore((state) => state.setErsterPunktLast);
  const setZweiterPunktDistanz = useFlexionStore((state) => state.setZweiterPunktDistanz);
  const setZweiterPunktLast = useFlexionStore((state) => state.setZweiterPunktLast);
  const setDritterPunktDistanz = useFlexionStore((state) => state.setDritterPunktDistanz);
  const setDritterPunktLast = useFlexionStore((state) => state.setDritterPunktLast);

  const [open, setopen] = useState(false);
  const [text, settext] = useState(getText(Sprache));

  function reset() {
    setopen(!open);
    setLänge(0);
    setErsterPunktLast(0);
    setErsterPunktDistanz(0);
    setZweiterPunktLast(0);
    setZweiterPunktDistanz(0);
    setDritterPunktLast(0);
    setDritterPunktDistanz(0);
  }

  useEffect(() => {
    settext(getText(Sprache));
  }, [Sprache]);

  return (
    <>
      <Snackbar
        open={open}
        message={text.Reset.Msg}
        timeout={1500}
        onClose={() => setopen(!open)}
      />
      <Button className='ResetButton' onClick={reset}>
        Reset
      </Button>
    </>
  );
}

export default ResetM;
